export const SITE_URL = 'https://javierparradev.vercel.app';
export const SITE_NAME = 'Javier Parra | Backend & Full Stack Developer';
export const AUTHOR = 'Javier Parra';
export const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;
